import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MileageModel } from 'src/app/models/system/mileage';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class MileageService extends OfflineDataService<MileageModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'CarManagement::CarMileage',
      http,
      errorService,
      events,
      'car_management/car_mileages/',
      'car_mileage',
      ['created_at', 'updated_at', 'created_by_id'],
      [],
      undefined,
      true
    );
  }
}
